// extracted by mini-css-extract-plugin
module.exports = {"title":"BuildingSectionEditName_title__1av9t","wrapper":"BuildingSectionEditName_wrapper__3HSBA","actions":"BuildingSectionEditName_actions__2T3Gj"};